/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLayout = createReactComponent("layout", "IconLayout", [
  [
    "path",
    {
      d: "M4 4m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z",
      key: "svg-0"
    }
  ],
  [
    "path",
    {
      d: "M4 13m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z",
      key: "svg-1"
    }
  ],
  [
    "path",
    {
      d: "M14 4m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z",
      key: "svg-2"
    }
  ]
]);

export { IconLayout as default };
//# sourceMappingURL=IconLayout.js.map
